<h3 mat-dialog-title>
   <ng-container *ngIf="canEdit$ | async">
      {{ editAction }}
   </ng-container>
   Function
   <ng-container *ngIf="!(canEdit$ | async)">Details</ng-container>
   <button class="full-editor float-right" (click)="fullEditor()" mat-button color="primary">
      Full Editor
      <mat-icon>arrow_forward</mat-icon>
   </button>
</h3>

<form [formGroup]="form" (ngSubmit)="save()">
   <mat-dialog-content>
      <mat-form-field>
         <input
            appAutoFocus
            matInput
            required
            type="text"
            placeholder="Name"
            formControlName="name"
            [readonly]="!(canEdit$ | async)"
         />
      </mat-form-field>
      <app-team-member-autocomplete
         [canEdit]="canEdit$ | async"
         [idFormControl]="getControl('leadId')"
         (optionSelected)="setLeadId($event)"
         placeholder="Lead"
      ></app-team-member-autocomplete>
      <mat-form-field>
         <input
            matInput
            type="text"
            placeholder="Purpose"
            formControlName="purpose"
            [readonly]="!(canEdit$ | async)"
         />
      </mat-form-field>
   </mat-dialog-content>
   <mat-dialog-actions>
      <div class="button-container">
         <button
            type="submit"
            mat-raised-button
            color="primary"
            *ngIf="canEdit$ | async"
            [disabled]="!form.valid"
         >
            Save
         </button>
         <button type="button" mat-raised-button (click)="cancel()">
            <span *ngIf="canEdit$ | async; else noEdit">Cancel</span>
            <ng-template #noEdit>Close</ng-template>
         </button>
      </div>
   </mat-dialog-actions>
</form>
